export const formatROE = async (licenceDetails: any, _caseTypeID: string, _application?: string) => {
    // ROE Licence View - Radio Operator Exam
    // licenceDetails = content.LICApplication.licence
    // Replicates the same field mapping as ROE application-details form
    
    const examDetails = licenceDetails?.ExamDetails || licenceDetails || {};
    
    // Normalise exam results from any legacy locations / casing
    const examResultsRaw: any[] = (
        examDetails.ExamResults ||
        examDetails.examResults ||
        licenceDetails?.examResults ||
        []
    );
    
    // Map results with proper field names matching application payload
    const mappedExamResults = (Array.isArray(examResultsRaw) ? examResultsRaw : [])
        .map((r: any) => {
            const rawAttempts = r.NumberofAttempts ?? r.attempts;
            let attemptsVal = '';
            if (rawAttempts !== undefined && rawAttempts !== null && rawAttempts !== '') {
                const num = Number(rawAttempts);
                if (!isNaN(num)) {
                    attemptsVal = num === 1 ? '1st Attempt' : num === 2 ? '2nd Attempt' : String(rawAttempts);
                } else if (typeof rawAttempts === 'string') {
                    // Normalize any legacy labels
                    if (/^1(a)?/i.test(rawAttempts)) attemptsVal = '1st Attempt';
                    else if (/^2(a)?/i.test(rawAttempts)) attemptsVal = '2nd Attempt';
                    else attemptsVal = rawAttempts;
                }
            }
            // Normalize result code to display label for UI: P/F -> Pass/Fail
            const rawRes = (r.Result ?? r.result ?? '').toString().trim();
            let resultLabel = rawRes;
            if (/^p$/i.test(rawRes) || /^pass$/i.test(rawRes)) resultLabel = 'Pass';
            else if (/^f$/i.test(rawRes) || /^fail$/i.test(rawRes)) resultLabel = 'Fail';
            
            return {
                studentName: r.IndividualName || r.studentName || r.name || '',
                idType: r.IDType || r.idType || '',
                idNumber: r.IDNo || r.idNumber || '',
                nationality: r.Nationality || r.nationality || '',
                nationalityLabel: r.Nationality || r.nationality || '',
                result: resultLabel,
                attempts: attemptsVal
            };
        })
        // Drop rows that are completely empty
        .filter(r => Object.values(r).some(v => v !== '' && v !== undefined && v !== null));

    const applicationDetailsValues = {
        // Licence name (fallback to static if backend omits)
        'application-details-licence-name': licenceDetails?.licenceName || 'Radio Operator Exam',
        // Use prefixed keys to match renderer's `${sectionID}-${field.id}` access pattern
        'exam-details-exam-type': examDetails.ExamType || '',
        'exam-details-exam-date': examDetails.ExamDate || '',
        'exam-details-exam-conducted-by': examDetails.ExamConductedBy || '',
        'exam-details-submission-type': (examDetails.SubType === 'ST1' || examDetails.SubType === 'ST2') ? examDetails.SubType : '',
        // Provide both legacy and canonical key names during transition so existing saved forms still populate.
        'exam-results': mappedExamResults,
        'exam-details-exam-results': mappedExamResults
    };

    const licence = {
        id: 'application-details',
        formID: 'application-details',
        hasError: false,
        title: 'Licence Details',
        values: applicationDetailsValues
    };

    return licence;
};

const roePayload = {
    formatROE
};

export default roePayload;
